import { render, staticRenderFns } from "./TagSelection.vue?vue&type=template&id=2a7cb275&scoped=true&"
import script from "./TagSelection.vue?vue&type=script&lang=ts&"
export * from "./TagSelection.vue?vue&type=script&lang=ts&"
import style0 from "./TagSelection.vue?vue&type=style&index=0&id=2a7cb275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7cb275",
  null
  
)

export default component.exports